import React, { useEffect, useState } from 'react'
import FilterManagement from '../../components/FilterManagement'
import { UiComponents } from "@simulanisindia/ui";
import { BackArrowIcon, Groups } from '../../Assets/Icons';
import { useNavigate } from 'react-router-dom';
import InvoiceTable from './InvoiceTable';
import apiClient from '../../apiClient';
import { SSO_URL } from '../../env';
import { GET_ALL_SUBSCRIPTION_LIST, GET_GROUP_LIST } from '../../apiClient/apiEndpoints';
import { INVOICE_LIMIT } from '../../Constant/constant';

const { BackButton, SearchBar, NormalGradientButton } = UiComponents;
const { SimFilter } = UiComponents;

const body = document.body;

const Invoice = () => {
    const [search, setSearch] = useState();
    const [querySearch, setQuerySearch] = useState();
    const [showfilter, setShowFilter] = useState(false);
    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [paginationPage, setPaginationPage] = useState(1);
    const [groupList, setGroupList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterCategoryOption, setFilterCategoryOption] = useState([]);
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [querySelectedCheckboxes, setQuerySelectedCheckboxes] = useState([]);
    
    const navigate = useNavigate()

    const backClick = () => {
        navigate(-1)
    }

    useEffect(()=>{
        const handler = setTimeout(()=>{
            setQuerySearch(search);
            setQuerySelectedCheckboxes(selectedCheckboxes);
        },750);
        return () => { clearTimeout(handler) };
    },[search, selectedCheckboxes]);

    const openFilter = () => {
        setShowFilter(!showfilter);
        if (!showfilter) {
            body.classList.add("filter-active");
        } else {
            body.classList.remove("filter-active");
        }
    };

    const getAllSubscriptionList = async (pageId, searchQuery = null, filterCheckboxes = []) => {
        try {
            let pageNumber = pageId || paginationPage;
            let data = await apiClient.get(`${SSO_URL}${GET_ALL_SUBSCRIPTION_LIST}`,{
                params: {
                    limit: INVOICE_LIMIT,
                    page: pageNumber,
                    search: searchQuery || null,
                    groupIds: filterCheckboxes.length > 0 ? filterCheckboxes.map(item => item.key) : null,
                }});

                setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
                setHasMore(data.length === INVOICE_LIMIT);
                setPaginationPage(data.length === INVOICE_LIMIT ? Number(pageNumber) + 1 : 1);

        } catch (error) {
            console.log(error);
        }
    };
    
    const getAllGroupChannelList =async() =>{
        try {
            let data = await apiClient.get(`${SSO_URL}${GET_GROUP_LIST}`);
            setGroupList(data);

            let filterList = [{
                name: "Groups Name",
                tags: data.map((item) => ({
                  name: item.name,
                  key: item.uuid,
                  value: item.uuid,
                })),
              }]

              setFilterCategoryOption(filterList);

        } catch (error) {
            
        }
    } ;

    useEffect(() => {
        getAllSubscriptionList(1, querySearch, querySelectedCheckboxes );
    }, [querySearch, querySelectedCheckboxes]);
    
    useEffect(() => {
        getAllGroupChannelList();
    }, []);
    
    const handleResetCheckBox = () =>{ }
    
    const handleLoadMoreList = () =>{
        getAllSubscriptionList(paginationPage, querySearch, querySelectedCheckboxes );
    }


    return (
        <>
            <div className="invoice-page">
                <div className="page-title with-functions">
                    <div className="title-back">
                        <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                        <h6>Invoice </h6>
                    </div>

                    <div className="functions">
                        <SearchBar
                            onClick={() => { }}
                            placeholder="Search..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        <FilterManagement openFilter={openFilter} selectedCheckboxes={selectedCheckboxes} />
                        <NormalGradientButton onClick={() => navigate('/organization/create')} icon={<Groups />} text="Create Organization" />
                    </div>
                </div>

                <div className="invoice-table">
                    <div className="colorborder">
                        <InvoiceTable list={list} hasMore={hasMore} handleLoadMoreList={handleLoadMoreList} />
                    </div> 
                </div>

            </div>

            <SimFilter
                showfilter={showfilter}
                selectedCheckboxes={selectedCheckboxes}
                setSelectedCheckboxes={setSelectedCheckboxes}
                filterOptions={filterCategoryOption}
                onToggleFilter={() => openFilter(null)}
                handleResetCheckBox={handleResetCheckBox}
            />

        </>
    )
}

export default Invoice;